import React from "react";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const spanStyle = {
  display: "inline-block",
  cursor: "pointer"
};

const FilterToolTip = () => (
  <Tippy
    appendTo={ref => {
      return ref.parentNode;
    }}
    trigger="click"
    arrow="true"
    placement="right"
    content={
      <span className="param-details">
        <ul>
          <li>
            <strong>Media Library</strong> – retrieves content from your Media
            Library
          </li>
          <li>
            <strong>Stream ID</strong> – retrieves content from a specific
            stream
          </li>
          <li>
            <strong>Product ID</strong> – retrieves content from a specific
            product stream
          </li>
          <li>
            <strong>Category ID</strong> – retrieves content from a specific
            category
          </li>
        </ul>
      </span>
    }
  >
    <span style={spanStyle} onClick={e => e.preventDefault()}>
      <FontAwesomeIcon icon="question-circle" />
    </span>
  </Tippy>
);

export default FilterToolTip;



// WEBPACK FOOTER //
// ./src/components/Sidebar/filterToolTip.js